import React, { useEffect } from 'react'

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { connect } from 'react-redux'
import querystring from 'query-string'

import { fetchTransactionData } from '../../redux/transaction/transaction.actions'
import { fetchUserAsync } from '../../redux/user/user.actions'
import { fetchTspAsync } from '../../redux/tsp/tsp.actions'
import EsignContentContainer from '../../components/esign-content/esign-content.container'
import EsignOverview from '../../components/esign-overview/esign-overview.component'
import loadNIASScript from '../../utils/load-nias-script'





const EsignPage = ({ location, fetchTransactionData, fetchUserAsync, fetchTspAsync}) => {

  const { token } = querystring.parse(location.search)

  useEffect(() => {
      toast(<div>U noći s 03.11.2026. na 04.11.2026. su planirani radovi na mrežnoj infrastrukturi.<br />
        Prilikom planiranih radova, u razdoblju 00:00 – 05:00 mogući su povremeni prekidi u radu usluga Platforme</div>, {
        style: {borderRadius: "6px", fontSize: "14px", padding: "14px"}
      });
  },[])
  
  useEffect(() => {
    if(token) {
      fetchTransactionData(token)
      fetchTspAsync()
      fetchUserAsync(token)
      
    } else {
      loadNIASScript(null, null)
    }
    
  }, [token])


  return (token) 
    ? <>
        <EsignContentContainer /> 
        <ToastContainer 
          position="top-center" 
          style={{width: "800px", textAlign: "center", borderRadius: "12px"}}
          autoClose={false}  />
      </>
    : <>
      <EsignOverview />
      <ToastContainer  
        position="top-center" 
        style={{width: "800px", textAlign: "center", borderRadius: "12px"}}
        autoClose={false} />
      </>
  
}


const mapDispatchToProps = dispatch => ({
  fetchTransactionData: token => dispatch(fetchTransactionData(token)),
  fetchTspAsync: ()=>dispatch(fetchTspAsync()),
  fetchUserAsync: token => dispatch(fetchUserAsync(token))
})


export default connect(null, mapDispatchToProps)(EsignPage)